module.exports = __webpack_public_path__ + "static/img/cli_02.d7f7c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cli_02.jpg
// module id = kFDx
// module chunks = 1